import React from 'react'
import s from '../seo/LayerCityIntroduction.less'
import useFirstAddressWithTownSeoPostcode from '../seo/useFirstAddressWithTownSeoPostcode'

const ZfeCityIntroduction = () => {
  const { town, postcode } = useFirstAddressWithTownSeoPostcode()

  return (
    <div className={s.root}>
      <h1 className={s.title}>
        ZFE {town}, {postcode}
      </h1>
      <p className={s.text}>
        Affichez sur la carte la zone de restriction Crit’Air pour la ville de {town} ({postcode}). Avec la vignette
        Crit’Air, la ville de {town} ({postcode}) met en place une zone à faible émission pour réduire la pollution de
        l'air. Cette carte vous permet de visualiser la zone concernée par les restrictions de circulation. Vous pouvez
        retrouver toutes les{' '}
        <a href="https://blog.mappy.com/vignette-critair-toutes-les-villes-concernees/">
          villes concernées par la vignette Crit’Air
        </a>{' '}
        sur notre blog.
      </p>
    </div>
  )
}

export default ZfeCityIntroduction
